<template>
  <featured-attributes :profile-id="profileId" />
</template>

<script>
import FeaturedAttributes from '@/modules/profiles/components/categorised-attributes/FeaturedAttributes'

export default {
  name: 'ProfileCategorisedAttributesPage',

  components: {
    FeaturedAttributes
  },

  data() {
    return {
      model: {},
      subscriptionPreferencesStatus: [],
      subscriptionPreferences: []
    }
  },

  computed: {
    readonly() {
      return !this.$can('CategorisedTagFeatured::Manage')
    },

    profileId() {
      return this.$route.query.profile_id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileCategorisedAttributesPage.vue